<script>
	import { ArchiveIcon, EyeIcon } from "svelte-feather-icons"
	export let device
</script>

{#if device}
	{#if device.state === "ACTIVE"}
  <img src="/images/state-active.svg" alt="ACTIVE" />
	{:else if device.state === "DISCONNECTED" }
  <img src="/images/state-disconnected.svg" alt="DISCONNECTED" />
	{:else}
		<img src="/images/state-standby.svg"  alt="GRS" />
	{/if}
{/if}

<style>


	img {
		height: 30px;
		margin-right:4px;
    padding: 4px;
		padding-top: 6px;
	}

	
</style>